"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionComponent = void 0;
var tslib_1 = require("tslib");
var custom_element_1 = require("@wk/custom-element");
var AccordionComponent = (function (_super) {
    tslib_1.__extends(AccordionComponent, _super);
    function AccordionComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AccordionComponent.prototype.renderCallback = function () {
        return (custom_element_1.h("div", { className: "wk-accordion" },
            custom_element_1.h("slot", null)));
    };
    AccordionComponent = tslib_1.__decorate([
        custom_element_1.element('wk-accordion')
    ], AccordionComponent);
    return AccordionComponent;
}(custom_element_1.CustomElement));
exports.AccordionComponent = AccordionComponent;
